import { render } from "./SectionFooter.vue?vue&type=template&id=88243770&scoped=true"
import script from "./SectionFooter.vue?vue&type=script&lang=js"
export * from "./SectionFooter.vue?vue&type=script&lang=js"

import "./SectionFooter.vue?vue&type=style&index=0&id=88243770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88243770"]])

export default __exports__